// @ts-check
import RoleOptionGroup from "./option-group.js";

RoleOptionGroup.define();

export default RoleOptionGroup;
export * from './option-group.js';

/**
 * @type {import("./option-group-globals.js")}
 */
